export enum WorkOrderFilterCategory {
  LAYER = 'layer',
  ASSIGNED_TO = 'assigned_to',
  SUBMITTED_BY = 'submitted_by',
  DATE_SUBMITTED = 'date_submitted',
  DATE_SCHEDULED = 'date_scheduled',
  DATE_COMPLETED = 'date_completed',
  DATE_EDITED = 'date_edited',
}

export enum WorkOrderFilterCondition {
  IS = 'is',
  IS_NOT = 'is_not',
}

export enum WorkOrderFilterJoin {
  AND = 'and',
  OR = 'or',
}

export enum WorkOrderFilterMode {
  PANEL = 'panel',
  PROMPT = 'prompt',
}
